import axios from 'axios';

export default {
  getToken: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    const { id } = payload;
    const url = `/engine/2fa/token/${id}`;
    axios({
      url: url,
      method: "GET",
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        const {status, token} = response.data;
        if (status === 0 && token) {
          commit('twofactor/SET_TOKEN', {id, token}, {root: true});
        }
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  }
};
